// Libs
import classNames from 'classnames/bind';
import { IconButton, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
// Others
import { IBaseFile } from '~/utils/interface/common';
// Styles, images, icons
import styles from './ItemFileAttachment.module.scss';
import { icons } from '~/assets';

type Props = {
  file: IBaseFile;
  index?: number;
  onRemoveFile?: (file: IBaseFile, index?: number) => void;
};

const cx = classNames.bind(styles);

const ItemFileAttachment = (props: Props) => {
  //#region Destructuring Props
  const { file, index, onRemoveFile } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Stack id='itemFileAttachmentComponent' className={cx('fileItem')} gap={4}>
      <Stack direction='row' gap={4} alignItems={'center'} className={cx('fileInfo')}>
        <img src={icons.commonIconFile} alt={t('common_alt_img')} className={cx('iconFile')} />

        <Typography className={cx('fileName')}>{file?.file?.name}</Typography>
      </Stack>

      <IconButton onClick={() => onRemoveFile?.(file, index)} className={cx('viewIcon')}>
        <img src={icons.commonIconTrashRed} alt={t('common_alt_img')} className={cx('iconFile')} />
      </IconButton>
    </Stack>
  );
};

export default ItemFileAttachment;
